import { WorkspaceConnectSettingDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { IFiltrableItemQueryDto } from '@common-modules/shared/model/filtrable-items/filtrable-item-query.dto';
import { IFiltrableItemDto } from '@common-modules/shared/model/filtrable-items/filtrable-item.dto';
import { FiltrableItemTypeEnum } from '@common-modules/shared/model/filtrable-items/types/filtrable-item-type-enum';
import { IFiltrableType } from '@common-modules/shared/model/filtrable-items/types/filtrable-type';
import { Type } from 'class-transformer';

export class CTMeasurementFiltrableItemDto implements ICTMeasurementFiltrableItemDto {
  @Type(() => Date)
  startDate: Date;
  @Type(() => Date)
  endDate: Date;
  filtrableType: ICTMeasurementFiltrableType;
}

export interface ICTMeasurementFiltrableItemDto extends IFiltrableItemDto { }

export interface ICTMeasurementFiltrableType extends IFiltrableType {
  workspaceConnectSetting: WorkspaceConnectSettingDto;
  pointId: string;
}

export class CTMeasurementFiltrableType implements ICTMeasurementFiltrableType {
  key: string;
  title: string;
  subtitle: string;
  workspaceConnectSetting: WorkspaceConnectSettingDto;
  pointId: string;
  type: FiltrableItemTypeEnum = FiltrableItemTypeEnum.CTMeasurement;
  unitType: string;


  constructor(init: Partial<CTMeasurementFiltrableType>) {
    Object.assign(this, init);
    this.key = `${init.pointId}-${this.workspaceConnectSetting.scenarioId}`;
  }
}

export class CTMeasurementFiltrableItemQueryDto implements IFiltrableItemQueryDto {
  startDate: Date;
  endDate: Date;
  apiEndpoint: string;
  extraParams: any;

  constructor(
    startDate: Date,
    endDate: Date,
    apiEndpoint: string,
    scenarioId: string,
    pointId: string,
  ) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.apiEndpoint = apiEndpoint;

    this.extraParams = {
      pointId,
      scenarioId,
    };
  }
}

export class CTMeasurementData {
  scenarioId: string;
  pointId: string;
  values: { [dateStr: string]: string };
  unitLabel: string;

  constructor(init: Partial<CTMeasurementData>) {
    Object.assign(this, init);
  }
}
